// extracted by mini-css-extract-plugin
export var equalColumn = "_ik-0";